/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/9/2020
 */


// import {getClassConstructorByName} from "@/utils/helpers.js";
import {plainToClass} from "@qwoach/class-transformer-wrapper";
import TeamMemberProfile from "@shared/Profile/TeamMemberProfile.js";

export function getClassConstructorByName(name,...a) {
	console.log("getClassConstructorByName name = ", name, ", TeamMemberProfile = ", TeamMemberProfile)
	let c = eval(name);
	return c//new c(...a);
}


export default (route) => {
	let meta = {}
	route.matched.forEach(obj => {
		Object.assign(meta, obj.meta)
	})
	console.log("meta = ", meta)
	console.log("route.params = ", route.params)
	let state = {}
	// if(window.history && window.history.state && window.history.state.customProps){
	// 	state = window.history.state.customProps
	// 	//TODO: restore type of the object from customPropTypes
	// 	// for(let key of Object.keys(state)){
	// 	// 	let typeName = window.history.state.customPropTypes[key]
	// 	// 	let type = getClassConstructorByName(typeName)
	// 	// 	console.log("typeName = ", typeName, ", type = ", type)
	// 	// 	state[key] = plainToClass(type, state[key])
	// 	// }
	// 	window.history.state.customPropTypes = null
	// 	window.history.state.customProps = null
	// }
	if(window.qwRouteGlobalState){
		state = window.qwRouteGlobalState
		delete window.qwRouteGlobalState
	}
		console.log("route.state = ", state)
	return {
		...state, //state must be first, so it can be overwritten by route.params
		...route.params,
		...route.query,
		...meta,
	}
}

